import React, { useState, useEffect,useRef} from 'react';
import axios from 'axios';
import PropTypes from 'prop-types'; 
import { Box, Spinner, Text } from '@chakra-ui/react';
import axiosInstance from './../services/axiosInstance';
import RegisterUsersButton from '../pages/js';

import useVideoTracking from './../../hooks/useVideoTracking';

const VideoPlayer = ({ idvdocipher,videoId,video  }) => {
  const [otp, setOtp] = useState('');
  const playerRef = useRef(null);
  const [playbackInfo, setPlaybackInfo] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useVideoTracking(videoId, playerRef);
  useEffect(() => {
    console.log("text",video)
    const fetchOtpAndPlaybackInfo = async () => {
      try {
        // Fetch OTP and playback info from your server
        const response = await axiosInstance.get(`/vdocipher/${idvdocipher}`);
        const { otp, playbackInfo } = response.data;

        // Store them in state
        setOtp(otp);
        setPlaybackInfo(playbackInfo);
        setLoading(false);
      } catch (error) {
        console.error('خطأ في جلب OTP ومعلومات التشغيل:', error); // Translated error message
        setError("فشل تحميل الفيديو. الرجاء المحاولة مرة أخرى لاحقًا."); // Translated error message
        setLoading(false);
      }
    };

    fetchOtpAndPlaybackInfo();
  }, [idvdocipher]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="360px" dir="rtl"> {/* Added dir="rtl" */}
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="360px" dir="rtl"> {/* Added dir="rtl" */}
        <Text color="red.500">{error}</Text>
      </Box>
    );
  }

  return (
    <Box width="100%" height={450} mx="auto" dir="rtl"> {/* Added dir="rtl" */}
      {otp && playbackInfo && (
        <iframe
        border={"2px black solid"}
          width="100%"
          height="100%"
          src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}`}
          allow="encrypted-media"
          allowFullScreen
          frameBorder="0"
        ></iframe>
      )}
     
    </Box>
  );
};
VideoPlayer.propTypes = {
  idvdocipher: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired
};
export default VideoPlayer;


